import { Button } from '@art-of-hospitality-solutions-llc/ui-kit/components/button';
import {
  Card,
  CardDescription,
  CardFooter,
  CardHeader,
} from '@art-of-hospitality-solutions-llc/ui-kit/components/card';
import { Heading } from '@art-of-hospitality-solutions-llc/ui-kit/components/heading';
import Breadcrumbs from '@Components/Breadcrumbs';
import { Link } from 'react-router-dom';

export default function Workspaces() {
  return (
    <div className="w-full">
      <Breadcrumbs navList={[{ name: 'Workspaces', href: '/workspaces' }]} />
      <div className="mt-8 mb-4 flex items-center justify-between">
        <div>
          <Heading>Workspaces</Heading>
          <p>Manage the workspaces within your organization.</p>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
        <Card className="h-full">
          <CardHeader>
            <Heading level="h2">Workspace Manager</Heading>
            <CardDescription>View and manage Workspaces.</CardDescription>
          </CardHeader>
          <CardFooter>
            <Button asChild>
              <Link to="/workspaces/manager">Workspace Manager</Link>
            </Button>
          </CardFooter>
        </Card>
        <Card className="h-full">
          <CardHeader>
            <Heading level="h2">Workspace Cards</Heading>
            <CardDescription>Card view of Workspaces</CardDescription>
          </CardHeader>
          <CardFooter>
            <Button asChild>
              <Link to="/workspaces/cards">Workspace Cards</Link>
            </Button>
          </CardFooter>
        </Card>
      </div>
    </div>
  );
}
